// extracted by mini-css-extract-plugin
export default {"message":"OTP_message__1jmu2","lightMessage":"OTP_lightMessage__1Cd0k","container":"OTP_container__2VHun","main":"OTP_main__3FppA","focus":"OTP_focus__BsReY","inputs":"OTP_inputs__2on5g","otpInputs":"OTP_otpInputs__16qpX","btn":"OTP_btn__2CzKr"};
    if(module.hot) {
      // 1741870133765
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  